class AleonaCartAttention {
  constructor() {
    this.interval = null;
    this.pending = this.readPending();

    window.addEventListener('aleona:cart-added', () => this.start());
    window.addEventListener('aleona:cart-opened', () => this.stop());
    document.addEventListener(
      'click',
      (event) => {
        if (event.target.closest('#cart-icon-bubble, [name="checkout"], #CartDrawer-Checkout, a[href*="/checkout"]')) {
          this.stop();
        }
      },
      true
    );
    document.addEventListener(
      'submit',
      (event) => {
        if (event.submitter?.matches('[name="checkout"], #CartDrawer-Checkout')) this.stop();
      },
      true
    );

    if (window.location.pathname.includes('/cart')) this.stop();
    else if (this.pending) this.start();
  }

  readPending() {
    try {
      return window.sessionStorage.getItem('aleona-cart-attention') === '1';
    } catch {
      return false;
    }
  }

  writePending(value) {
    try {
      if (value) window.sessionStorage.setItem('aleona-cart-attention', '1');
      else window.sessionStorage.removeItem('aleona-cart-attention');
    } catch {
      // Storage can be unavailable in privacy-focused in-app browsers.
    }
  }

  start() {
    this.pending = true;
    this.writePending(true);
    this.pulse();
    window.clearInterval(this.interval);
    this.interval = window.setInterval(() => this.pulse(), 4000);
  }

  stop() {
    this.pending = false;
    this.writePending(false);
    window.clearInterval(this.interval);
    this.interval = null;
    document.querySelector('#cart-icon-bubble')?.classList.remove('aleona-cart-pulse');
  }

  pulse() {
    if (!this.pending || document.hidden) return;
    const icon = document.querySelector('#cart-icon-bubble');
    if (!icon) return;
    icon.classList.remove('aleona-cart-pulse');
    window.requestAnimationFrame(() => {
      icon.classList.add('aleona-cart-pulse');
      window.setTimeout(() => icon.classList.remove('aleona-cart-pulse'), 1100);
    });
  }
}

new AleonaCartAttention();
